import React, { useState, useEffect } from "react";

import styles from "./tab-screen-two.module.scss";

export default function TabScreenTwo(props) {
  const [state, setState] = useState({});

  useEffect(() => {}, []);

  return (
    <main className={styles.tab_screen_two_container}>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloremque ad,
      sapiente sunt nihil soluta dolorum. Consequuntur harum, ullam architecto
      fugit vel illum voluptatem, suscipit inventore, dolore perspiciatis sit
      deserunt blanditiis! Explicabo ab repellendus vero amet tempore minus
      iusto suscipit ut? Reprehenderit minus beatae necessitatibus quae
      praesentium laborum corporis autem voluptates aut, ducimus dolorum placeat
      distinctio pariatur, excepturi repudiandae quam ad! Possimus impedit
      quaerat corrupti dolore at obcaecati quidem adipisci debitis minus,
      voluptates eaque deleniti ut mollitia asperiores in voluptatum beatae
      porro laudantium! Dicta harum quod, fuga dolorum aliquam maxime unde.
      Molestias veniam beatae voluptate mollitia dolore numquam velit? Sunt, et
      a molestiae aperiam, doloremque autem hic expedita nihil quia beatae omnis
      ad necessitatibus suscipit, sit cumque sequi obcaecati nisi minus. Tenetur
      ullam totam voluptates. Ipsa aut possimus atque dolor natus, obcaecati
      tempora quibusdam nam praesentium. Ducimus omnis expedita repudiandae,
      nesciunt, nihil tempora, molestiae optio saepe consequatur dolore eligendi
    </main>
  );
}
